import { usePostPortfolioLifeInsuranceMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioLifeInsuranceMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { getLifeInsuranceCreateFormDefaultValues } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormDefaults";
import {
	getLifeInsuranceFormSchema,
	type LifeInsuranceFormOutput,
} from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormSchema";
import { mapLifeInsuranceCreateFormToRequest } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/mapLifeInsuranceFormToRequest";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateLifeInsuranceForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioLifeInsuranceMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getLifeInsuranceFormSchema(t),
		defaultValues: getLifeInsuranceCreateFormDefaultValues(),
		mutate: (data: LifeInsuranceFormOutput, options) => {
			mutate(mapLifeInsuranceCreateFormToRequest(data), options);
		},
		successRoute: Routing.Portfolio.PortfolioAddLifeInsuranceSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
